// extracted by mini-css-extract-plugin
module.exports = {"header":"GridView_header__dvaWY","title":"GridView_title__iplbF","description":"GridView_description__gkFqL","link":"GridView_link__EpEhm"};